import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Header } from "../components/Header";
import { AudioCard } from "../components/AudioCard";
import { ChevronLeft, Headphones } from "lucide-react";
import { motion } from "framer-motion";

const API = `/api`;

export default function AudioLibraryPage() {
  const [audios, setAudios] = useState([]);
  useEffect(() => { axios.get(`${API}/audio/library`).then(r => setAudios(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Link to="/dashboard" className="text-sm text-[#6A7771] hover:text-[#6B8576] flex items-center gap-1 mb-6 transition-colors duration-200"><ChevronLeft className="w-4 h-4" strokeWidth={1.5} /> Retour</Link>
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
          <h1 className="text-3xl font-semibold text-[#2C3531] mb-2" style={{ fontFamily: 'Outfit' }}>Mes séances audio</h1>
          <p className="text-[#6A7771] mb-8">Écoutez vos séances débloquées par votre thérapeute</p>
        </motion.div>
        <div className="space-y-3">
          {audios.map((a, i) => (
            <motion.div key={a.id} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
              <AudioCard audio={a} />
            </motion.div>
          ))}
          {audios.length === 0 && (
            <div className="text-center py-16 text-[#6A7771]">
              <Headphones className="w-12 h-12 mx-auto mb-3 opacity-20" strokeWidth={1.5} />
              <p className="font-medium">Aucune séance audio disponible</p>
              <p className="text-sm mt-1 opacity-70">Votre thérapeute vous débloquera des séances au fur et à mesure</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
